import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ZoningCodeService } from '../../core/services';
import { LoaderService } from '../../../shared/services';
import { CalibrationSetCollectionName, TableType } from '../../../shared/enums';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'zones-table',
    template: `
        <div *ngIf="zoningCode">
            <ziq-horizontal-scroll-table
                [table]="table"
                [currentTab]="currentTab"
                [showRequiredFieldsSwitch]="showRequiredFieldsSwitch"
            ></ziq-horizontal-scroll-table>
        </div>
    `,
    styleUrls: ['./zones-table.component.scss']

})
export class ZonesTableComponent implements OnInit {
    @HostBinding('class')
    readonly hostClass = 'zones-table';

    @Input()
    currentTab: string;

    @Input()
    type: TableType;

    private _table: any;

    constructor(private readonly zcService: ZoningCodeService, private loaderService: LoaderService) {}

    zoningCode: IZoningCodeModel;
    private zoningCode$: Subscription;

    get table() {
        if (!this.zoningCode) {
            return null;
        }

        if (!this._table) {
            switch (this.type) {
                case TableType.CALIBRATION_GENERAL:
                    this._table = this.zoningCode.tables[this.currentTab].generalTable;
                    break;
                case TableType.CALIBRATION_PARKING:
                    this._table = this.zoningCode.tables[this.currentTab].parkingTable;
                    break;
                case TableType.CALIBRATION_USE_CAPACITY:
                    this._table = this.zoningCode.tables[this.currentTab].useCapacityTable;
                    break;
                case TableType.CALIBRATION_BONUS:
                    this._table = this.zoningCode.tables[this.currentTab].bonusTable;
                    break;
            }
        }
        return this._table;
    }

    get showRequiredFieldsSwitch(): boolean {
        return (
            this.currentTab === CalibrationSetCollectionName.CALIBRATION_ZONE_COMBINATION &&
            this.type === TableType.CALIBRATION_GENERAL
        );
    }

    ngOnInit() {
        this.loaderService.show();
        this.zoningCode$ = this.zcService.zoningCodes.pipe(filter(zc => zc !== null && zc.length > 0)).subscribe(zc => {
            this.zoningCode = zc[0];
            if (!this.zoningCode) {
                return;
            }
            this.zoningCode.initCalibrationSetTable(this.type, this.currentTab);
            this.loaderService.hide();
        });
    }

    ngOnDestroy(): void {
        this.zoningCode$ && this.zoningCode$.unsubscribe();
    }
}
